import Cookies                        from "js-cookie";
import dynamic                        from "next/dynamic";
import React, { useEffect, useState } from "react";
import { initGA, initGTM }            from "_analytics/index";
import { useSetInterestialPopup }     from "_common/hooks/global";
/* import { isInsideThirdPartyApp, loginThirdPartyUser } from "_root/thirdParty";
 * import { createAuthData }                             from "_services/api/user"; */
import { isPageRoute }                              from "_common/utils";
import { useRouter }                                from "next/router";
import { useTimeout }                               from "@mantine/hooks";
import { useGetLoginPopup, useGetInterestialPopup } from "_common/hooks/global";
import { useGetLiveChatInfoPopup }                  from "_common/hooks/global";

const InterestialPopup  = dynamic ( () => import ( "_components/molecules/interestialPopupNew" ) );
const LoginContainer    = dynamic ( () => import ( "_components/pages/auth" ), { ssr: false } );
const LiveChatInfoPopup = dynamic ( () => import ( "_components/molecules/liveChatInformationPopup" ), { ssr: false } );

export default function withAuth ( WrappedComponent ) {
	const component = props => {
		const [ isPaytmUserState, setIsPaytmUser ] = useState ( false );
		const setInterestialPopup                  = useSetInterestialPopup ();

		const { start, clear } = useTimeout ( () => {
			setInterestialPopup ( true );
		}, 10000 );

		const interestialPopup  = useGetInterestialPopup ();
		const liveChatInfoPopup = useGetLiveChatInfoPopup ();
		const loginPopup        = useGetLoginPopup ();

		const router     = useRouter ();
		const isHomePage = isPageRoute ( { page: "home", router } );
		/* const isActivatePage  = isPageRoute ( { page: "activate", router } );
		 * const isModeratorPage = isPageRoute ( { page: "modfeed", router } ) || isPageRoute ( { page: "mods", router } ); */

		useEffect ( () => {
			init ();
		}, [] );

		useEffect ( () => {
			if ( isHomePage )
				start ();
			else
				clear ();
		}, [ router.pathname ] );

		const init = async () => {
			/* await handleAuthFlow (); */

			initGA ();
			initGTM ();

			const isPaytmUser = Cookies.get ( "isPaytmUser" );

			setIsPaytmUser ( isPaytmUser ? true : false );

		};

		/*         const handleAuthFlow = async () => {
 *             const thirdPartyApp = isInsideThirdPartyApp ();
 *
 *             if ( thirdPartyApp && !userId )
 *                 await loginThirdPartyUser ( { appName: thirdPartyApp } );
 *
 *             if ( userId )
 *                 return checkAndUpdateUserProfile ( userId );
 *
 *             // first time user
 *             try {
 *                 await createAuthData ();
 *             } catch ( error ) {
 *                 return error;
 *             }
 *         }; */

		const { withAuthQuery } = props;

		const isPaytmUser = withAuthQuery && withAuthQuery.isPaytmUser === "true" ? true : isPaytmUserState;

		return (
			<React.Fragment>
				<WrappedComponent { ...props }
					isPaytmUser = { isPaytmUser }
				/>

				{
					loginPopup && (
						<LoginContainer showLoginDialog = { loginPopup } />
					)
				}

				<InterestialPopup
					onClose = { () => setInterestialPopup ( false ) }
					popup   = { interestialPopup }
				/>

				{
					liveChatInfoPopup && (
						<LiveChatInfoPopup
							popup    = { liveChatInfoPopup }
						/>
					)
				}

			</React.Fragment>
		);
	};

	return component;
}
